/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: 0 auto ${spacing.xxxl}px;
`;
